// Content data for CareFirst Home Health Services LLC landing page

export const BRAND = {
  name: "CareFirst",
  full: "CareFirst Home Health Services LLC",
  sub: "HOME HEALTH SERVICES LLC",
  tagline: "Compassion. Care. Always.",
  motto: "Care You Can Trust. Family You Can Count On.",
  banner: "CARING FOR YOU. CARING FOR YOUR FAMILY.",
  website: "carefirstoh.com",
};

export const IMAGES = {
  heroCaregiver: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxob21lJTIwY2FyZSUyMHNlbmlvcnxlbnwwfHx8fDE3ODY5MTM5Mjl8MA&ixlib=rb-4.1.0&q=85",
  eligibility: "https://images.unsplash.com/photo-1762955911769-d652ceaa94bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxob21lJTIwY2FyZSUyMHNlbmlvcnxlbnwwfHx8fDE3ODY5MTM5Mjl8MA&ixlib=rb-4.1.0&q=85",
  nurseSmiling: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxudXJzZSUyMGVsZGVybHklMjBwYXRpZW50fGVufDB8fHx8MTc4NjkxMzkzNHww&ixlib=rb-4.1.0&q=85",
  medication: "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtZWRpY2F0aW9uJTIwcGlsbHN8ZW58MHx8fHwxNzg2OTEzOTYwfDA&ixlib=rb-4.1.0&q=85",
  meal: "https://images.unsplash.com/photo-1507048331197-7d4ac70811cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxtZWFsJTIwcHJlcGFyYXRpb258ZW58MHx8fHwxNzg2OTEzOTYwfDA&ixlib=rb-4.1.0&q=85",
  dressing: "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBzZW5pb3J8ZW58MHx8fHwxNzg2OTEzOTY4fDA&ixlib=rb-4.1.0&q=85",
  grooming: "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxlbGRlcmx5JTIwY2FyZSUyMGhvbWV8ZW58MHx8fHwxNzg3MDgwMTg0fDA&ixlib=rb-4.1.0&q=85",
  nurseBP: "https://images.pexels.com/photos/7345474/pexels-photo-7345474.jpeg?auto=compress&cs=tinysrgb&w=1200",
  recoveryWalker: "https://images.pexels.com/photos/34328480/pexels-photo-34328480.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Why Us?", href: "#why" },
  { label: "Accreditation", href: "#accreditation" },
  { label: "Contact", href: "#contact" },
];

// Rise-style benefit cards
export const RISE_BENEFITS = [
  { icon: "shield", title: "Hire a Family Member or Friend" },
  { icon: "cash", title: "Competitive Pay" },
  { icon: "wallet", title: "Bi-weekly Pay & Direct Deposit" },
];

export const ACCREDITATION = {
  heading: "Central Ohio's Trusted CHAP Accredited Home Care Provider",
  body: "CareFirst Home Health Services is committed to providing the highest level of care and service to our clients and partners. Our CHAP Seal of Accreditation for Home Health reflects our dedication to excellence, quality standards, and compassionate, reliable skilled and non-skilled services across Central Ohio.",
  seal: "/chap-seal.png",
};

export const PARTNERS = {
  grid: "/partners.png",
  wellcare: "/wellcare-buckeye.png",
  medicaid: "/ohio-medicaid.png",
};

export const ABOUT = {
  heading: "Caring for You. Caring for Your Family.",
  body: "CareFirst Home Health Services LLC is a certified, CHAP-accredited home health agency proudly serving Columbus and Central Ohio. Our mission is to deliver compassionate, professional, and personalized care that helps our clients live safely and independently in the comfort of their own homes. From skilled nursing to everyday personal care, our dedicated caregivers treat every client like family.",
  highlights: [
    { icon: "award", text: "Certified & CHAP Accredited Agency" },
    { icon: "map", text: "Proudly Serving Central Ohio" },
    { icon: "heart", text: "Skilled & Non-Skilled Home Care" },
  ],
};

export const CONTACT = {
  city: "COLUMBUS",
  phone: "614-368-2239",
  phoneRaw: "+16143682239",
  phone2: "614-563-3402",
  phone2Raw: "+16145633402",
  fax: "614-343-2247",
  email: "info@carefirstoh.com",
  email2: "carefirst1964@gmail.com",
  address: ["6740 Huntley Rd #107,", "Columbus, OH 43229"],
};

export const SOCIALS = ["facebook", "twitter", "instagram", "youtube", "linkedin"];

// Ohio Medicaid MCOs / approved insurers CareFirst works with
export const INSURANCE = [
  { name: "Molina Healthcare", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/mo.png" },
  { name: "Passport Health Plan", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/passport-health-plan-logocopy.png" },
  { name: "Senior Options LLC", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/senior.png" },
  { name: "Aetna", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/atena.png" },
  { name: "Buckeye Health", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/sitelogo.png" },
  { name: "CareSource", logo: "https://www.completehomecareoh.com/wp-content/uploads/2024/11/cr.png" },
];

// Proudly Accepted By badges (from CareFirst flyer)
export const ACCEPTED = [
  { icon: "medicare", title: "MEDICARE", desc: "Certified by Medicare to provide skilled nursing and therapy services." },
  { icon: "medicaid", title: "MEDICAID", desc: "Approved provider for Medicaid to deliver compassionate care at home." },
  { icon: "passport", title: "PASSPORT", desc: "PASSPORT Waiver provider supporting independence and quality of life." },
  { icon: "dodd", title: "DODD", desc: "Provider for DODD services supporting individuals with developmental disabilities." },
  { icon: "va", title: "VA PATIENTS", desc: "Proud to serve our Veterans with respect, dignity, and quality care." },
];

export const ELIGIBILITY_POINTS = [
  "You are a resident of Ohio",
  "You are approved for home care with CARESOURCE, Medicaid (Passport) or an MCO (BUCKEYE, AETNA or MOLINA)",
  "You need help with activities for daily living",
  "You need a caregiver from our agency to take care of you",
  "You want a friend or family member to get paid to take care of you",
];

export const VIDEO_ID = "7QhnKYwAkVM";

export const BENEFITS = [
  { icon: "money", title: "Best Pay for Care Givers" },
  { icon: "family", title: "Hire a Family Member or Friend" },
  { icon: "beach", title: "Get Paid for Holidays" },
  { icon: "insurance", title: "Health Insurance, Vision & Dental, Life Insurance and Other Benefits Available!" },
  { icon: "wallet", title: "Weekly Pay & Direct Deposit" },
  { icon: "worldwide", title: "Proudly Serving Central Ohio" },
];

export const OFFICES = [
  {
    city: "Columbus",
    phone: "614-368-2239",
    phoneRaw: "+16143682239",
    address: ["6740 Huntley Rd #107,", "Columbus, OH 43229"],
  },
];

// Why Choose CareFirst (from flyer)
export const WHY_CAREFIRST = [
  { icon: "users", text: "Compassionate & Professional Caregivers" },
  { icon: "shield", text: "Individualized Care Plans" },
  { icon: "home", text: "Care in the Comfort of Home" },
  { icon: "heart", text: "Improving Health, Enhancing Quality of Life" },
];

export const SERVICES = [
  { title: "Skilled Nursing", desc: "Professional skilled nursing and therapy services in your home.", img: IMAGES.medication },
  { title: "Personal Care", desc: "Bathing, dressing and grooming assistance with dignity and respect.", img: IMAGES.dressing },
  { title: "Meal Preparation", desc: "Because eating right is hard as you age, we make sure you eat healthy.", img: IMAGES.meal },
  { title: "Companionship", desc: "Warm companionship, mobility help and light housekeeping.", img: IMAGES.grooming },
];

export const NETWORK = [
  { label: "Skilled Nursing", href: "#" },
  { label: "Medication Management", href: "#" },
  { label: "Personal Care", href: "#" },
  { label: "Bathing & Dressing", href: "#" },
  { label: "Meal Preparation", href: "#" },
  { label: "Companionship", href: "#" },
  { label: "Light Housekeeping", href: "#" },
  { label: "Respite Care", href: "#" },
  { label: "Mobility Assistance", href: "#" },
];
